import React, { useEffect, useRef, useState } from "react";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete } from "react-icons/md";
import { Button } from "@progress/kendo-react-buttons";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import { Switch } from "@progress/kendo-react-inputs";
import IconButton from "../../components/common/IconButton";
import {
  ProductSubCategoryActiveInactive,
  deleteProductSubCategory,
  getAllProductSubCategory,
} from "./services/productsubcategory.services";
import CreateProductSubCategory from "./CreateProductSubCategory";
import {
  clearProductSubCategoryID,
  setProductSubCategoryID,
} from "./productsubcategorySlice";
import ButtonCreate from "../../components/muidrawer/ButtonCreate";
import AppDrawer from "../../components/muidrawer/Drawer";
import ButtonEdit from "../../components/muidrawer/ButtonEdit";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";

const ProductSubCategory: React.FC = () => {
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const isDrawerOpen = useAppSelector((state) => state.muidrawer.open);
  const drawerName = useAppSelector((state) => state.muidrawer.name);
  const FilterProductSubCategory = useAppSelector(
    (state) => state.productsubcategory.FilterProductSubCategory
  );
  useEffect(() => {
    dispatch(getAllProductSubCategory({ ...FilterProductSubCategory }));
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  return (
    <>
      <DeleteProductSubcategoryDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Product Sub Category
          </Typography.h4>
          {isAddAccess && (
            <ButtonCreate
              label="Add New"
              drawerName="productsubcategoryForm"
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <ProductCategoryGridComponent />
        </GridLayoutItem>
        {isDrawerOpen && drawerName === "productsubcategoryForm" && (
          <AppDrawer>
            <CreateProductSubCategory />
          </AppDrawer>
        )}
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}
const initialDataState: PageState = { skip: 0, take: 10 };
const ProductCategoryGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const ProductSubCategoryList = useAppSelector(
    (state) => state.productsubcategory.ProductSubCategoryList
  );
  const FilterProductSubCategory = useAppSelector(
    (state) => state.productsubcategory.FilterProductSubCategory
  );
  const loading = useAppSelector((state) => state.productsubcategory.loading);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All"
        ? ProductSubCategoryList.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (ID: any) => {
      dispatch(openDialog("deleteProductSubCategory"));
      dispatch(setProductSubCategoryID(ID));
    };
    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <ButtonEdit
            ID={props.dataItem.item_subcategory_guid}
            name="productsubcategoryForm"
            themeColor="success"
            tooltipTitle="Edit"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem.item_subcategory_guid)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.isactive);

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        item_subcategory_guid: props.dataItem.item_subcategory_guid,
        isactive: !IsActive,
      };
      dispatch(ProductSubCategoryActiveInactive(data)).then((response: any) => {
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllProductSubCategory({ ...FilterProductSubCategory }));
        } else {
          dispatch(getAllProductSubCategory({ ...FilterProductSubCategory }));
        }
      });
    };

    return (
      <td style={{ textAlign: "center" }}>
        <Switch
          disabled={isEditAccess ? false : true}
          name="isactive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        scrollable="scrollable"
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        data={
          filter
            ? filterBy(ProductSubCategoryList, filter).slice(
                page.skip,
                page.take + page.skip
              )
            : ProductSubCategoryList.slice(page.skip, page.take + page.skip)
        }
        onFilterChange={handleFilterChange}
        skip={page.skip}
        take={page.take}
        total={ProductSubCategoryList.length}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 15, "All"],
          pageSizeValue: pageSizeValue,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="item_subcategory_name"
          title="Product Sub Category"
          cells={{
            data: (props: any) => (
              <td>
                <ButtonEdit
                  isEditAccess={isEditAccess}
                  ID={props.dataItem.item_subcategory_guid}
                  name="productsubcategoryForm"
                  label={props.dataItem?.item_subcategory_name}
                />
              </td>
            ),
          }}
        />
        <Column field="item_category_name" title="Product Category" />
        <Column field="short_code" title="Short Code" />
        <Column
          field="isactive"
          title="Status"
          cells={{ data: MyActiveInActtiveCommandCell }}
          width={"90px"}
          filterable={false}
          locked={true}
        />
        {isEditAccess && isDeleteAccess && (
          <Column
            field="item_subcategory_guid"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"110px"}
            filterable={false}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteProductSubcategoryDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const ProductSubCategoryID = useAppSelector(
    (state) => state.productsubcategory.ProductSubCategoryID
  );
  const FilterProductSubCategory = useAppSelector(
    (state) => state.productsubcategory.FilterProductSubCategory
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteProductSubCategory(ID));
      if (response.payload?.Data.Status === 200) {
        dispatch(getAllProductSubCategory({ ...FilterProductSubCategory }));
        dispatch(closeDialog());
        dispatch(clearProductSubCategoryID());
      } else {
        dispatch(getAllProductSubCategory({ ...FilterProductSubCategory }));
        dispatch(closeDialog());
        dispatch(clearProductSubCategoryID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteProductSubCategory" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Product Sub Category?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Product Sub Category?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => {
                    handleDeleteAction(ProductSubCategoryID);
                  }}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default ProductSubCategory;
